import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type LicenceState = CommonTableState;


const initialState: LicenceState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "company.name", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: [
            "company.id",
            "company.vatNumber",
            "company.idNumber",
            "company.email",
            "company.phone",
            "company.dataBox",
            "responsiblePerson.id",
            "credit",
            "valid",
            "approvalAllowed",
            "itemsAllowed",
            "centreSharesAllowed",
            "responsiblePerson.email",
            "responsiblePerson.phone",
            "responsiblePerson.dataBox",
            "creator",
            "created",
            "mrt-row-actions",
        ],
        columnVisibility: {
            companyEmail: false,
            companyPhone: false,
            companyDataBox: false,
            responsiblePersonEmail: false,
            responsiblePersonPhone: false,
            responsiblePersonDataBox: false,
            creator: false,
            created: false,
        },
        density: "compact",
    },
};

export const licenceSlice = createSlice({
    name: "licence",
    initialState: initialState,
    reducers: {
        updateLicenceTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateLicenceTableState} = licenceSlice.actions;

export default licenceSlice.reducer;
